export const API_URL = process.env.REACT_APP_API_URL;
export const CDN = process.env.REACT_APP_CDN_URL;
